import { BaseModel } from "@blue-chip/core";
import Spec from "./Spec";
import SpecShipment from "./SpecShipment";

export default class Shipment extends BaseModel {
  static get belongsTo() {
    return [Spec, SpecShipment];
  }
}
